<template>
<el-card>
    <template v-slot:header>
    <div class="clearfix">
        <span style="font-weight: bold;"><i class="el-icon-s-data" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>Expression of Target Genes</span>
    </div>
    </template>
    <div class="container">
    <el-container>
        <el-main>
        <div id="upbar" style="width:100%;height:500px;"></div> 
        </el-main>
    </el-container>
    </div>
</el-card>
</template>

<script>
export default {
props: {
    species: {
    type: String,
    required: true
    },
    tissue: {
    type: String,
    required: true
    }
},
data() {
    return {
    chartData: [],
    url: "http://183.175.59.4/devenhancer/", // 后端接口地址
    chartGraph: null, // echarts 关系图实例
    };
},
mounted() {
    // 初始化 echarts 关系图实例
    this.chartGraph = this.$echarts.init(document.getElementById('upbar'));
    this.handleAnalysis();
},
methods: {
    handleAnalysis() {
    // 发送请求获取后端数据
    const params = { Species: this.species, Tissue: this.tissue };
    this.$axios.get(this.url + "upexpr" + "/", { params })
        .then((response) => {
            // 对数据进行处理
            const res = response.data;
            if (Array.isArray(res) && res.length > 0) {
                const geneNames = res.map(row => row.SYMBOL); // 存储基因名称
                const geneData = res.map(row => row.Upex); // 存储基因表达数据

                const sortedGeneData = geneData.sort((a, b) => b - a); // 根据基因表达数据的值大小进行排序
                const top20GeneData = sortedGeneData.slice(0, 20); // 仅截取前20个基因表达数据
                const top20GeneNames = top20GeneData.map((value, index) => geneNames[geneData.indexOf(value)]); // 获取对应的基因名称

                const maxExpression = Math.max(...top20GeneData); // 获取expression的最大值

                const option = {
                    tooltip: {
                        position: 'top',
                        formatter: function(params) {
                            return `Gene: ${params.name}<br>Expression: ${params.value}`;
                        }
                    },
                    animation: false,
                    grid: {
                        height: '70%',
                        top: '10%'
                    },
                    xAxis: {
                        type: 'category',
                        data: top20GeneNames, // 设置基因名称作为 x 轴标签数据
                        axisLabel: {
                            rotate: 45, // 旋转角度
                            fontSize: 10 // 字体大小
                        }
                    },
                    yAxis: {
                        type: 'value',
                        name: 'TPM' // 设置 y 轴名称
                    },
                    visualMap: {
                        min: 0,
                        max: maxExpression,
                        calculable: true,
                        orient: 'horizontal',
                        left: 'center',
                        bottom: '0%'
                    },
                    series: [
                        {
                            name: 'Gene Expression',
                            type: 'bar',
                            data: top20GeneData,
                            label: {
                                show: false,
                            },
                            emphasis: {
                                itemStyle: {
                                    borderColor: '#FF7070'
                                }
                            }
                        }
                    ]
                };
                // 使用 echarts 关系图实例设置选项和数据
                this.chartGraph.setOption(option);
            } else {
                this.$message.warning('No data available.');
            }
        })
        .catch((error) => {
            console.error(error);
            this.$message.error('Failed to fetch data.');
        });
},
},
};
</script>

<style scoped>
.custom-button1 {
    float: right;
    background-color: #2C3E50;
    border: 1px solid #2C3E50;
    color: #FFF2E7; /* 设置文字颜色为白色，以提高对比度 */
}
.custom-button2 {
    float: right;
    background-color: #2C3E50;
    border: 1px solid #2C3E50;
    color: #FFF2E7; /* 设置文字颜色为白色，以提高对比度 */
    margin-right: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/Target/Targetexpr.vue